import type { ReceiptTemplate } from '../schema';

export const popeyesTemplate: ReceiptTemplate = {
  id: 'popeyes',
  name: 'Popeyes Receipt',
  brand: 'POPEYES',
  description: 'Popeyes Louisiana Kitchen receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'popeyes-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/popeyes.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'LOUISIANA KITCHEN',
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'popeyes-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '01/04/2026 1:15 PM\nORDER #847',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'popeyes-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'SPICY 3PC COMBO', quantity: '1', price: '10.99', sku: '' },
          { id: '2', name: 'CAJUN FRIES REG', quantity: '1', price: '2.99', sku: '' },
          { id: '3', name: 'BISCUIT', quantity: '1', price: '1.29', sku: '' },
          { id: '4', name: 'DRINK MED', quantity: '1', price: '2.49', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'popeyes-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '17.76', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '1.47', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '19.23', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'popeyes-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'popeyes-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'LOVE THAT CHICKEN\nFROM POPEYES!\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

